import { Spin } from 'antd'
import React from 'react'
import { LoadingOutlined } from "@ant-design/icons";

function HacktonomyPageLoader() {
  return (
     <div style={{display:"block",textAlign:"center",padding:"50px"}}>
       <div style={{display:"inline-block", padding:"20px",minWidth:"180px", boxShadow:"0px 0px 8px #ccc", borderRadius:"8px"}}>
         <Spin indicator={<LoadingOutlined spin />} style={{color:"#0891b2"}} size="large"/>
      <h2 style={{marginTop:"25px"}}>Hacktonomy</h2>
       </div>
      </div>
  )
}

export default HacktonomyPageLoader;